import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '2964287970431808';
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}
/**
 * Loads the Meta Pixel and fires PageView + ViewContent on mount.
 * Exposes trackAddToCart() helper for checkout CTAs.
 */
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    // Inject the official Meta Pixel base code (only once)
    if (!window.fbq) {
      const f: any = window;
      const n: any = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      f.fbq = n;
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const target = document.head || document.getElementsByTagName('script')[0]?.parentNode || document.body;
      if (target) target.appendChild(script);
      window.fbq('init', PIXEL_ID);
    }
    // Fire standard events on load
    window.fbq('track', 'PageView');
    window.fbq('track', 'ViewContent', {
      content_name: 'Wellaging Argentino - Landing',
      content_category: 'Ebook / Wellness',
      content_ids: ['wellaging-argentino-360'],
      content_type: 'product',
      value: 17990,
      currency: 'ARS'
    });
  }, []);
  return <noscript data-id="element-378">
      <img height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-379" />
    </noscript>;
}
/**
 * Fires an AddToCart event. Call from checkout CTA onClick handlers.
 */
export function trackAddToCart(opts: {
  value: number;
  contentName: string;
  contentId: string;
}) {
  if (typeof window === 'undefined' || !window.fbq) return;
  window.fbq('track', 'AddToCart', {
    content_name: opts.contentName,
    content_ids: [opts.contentId],
    content_type: 'product',
    value: opts.value,
    currency: 'ARS'
  });
}